import { render } from "./rich-text.vue?vue&type=template&id=7cc74b29"
import script from "./rich-text.vue?vue&type=script&lang=js"
export * from "./rich-text.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/form/field/rich-text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cc74b29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cc74b29', __exports__)) {
    console.log('reload')
    api.reload('7cc74b29', __exports__)
  }
  
  module.hot.accept("./rich-text.vue?vue&type=template&id=7cc74b29", () => {
    console.log('re-render')
    api.rerender('7cc74b29', render)
  })

}


export default __exports__